import { CloseIcon } from "$components/icons";
import { IconButton, styled, Typography } from "@material-ui/core";
import React from "react";

const Header = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  alignItems: "center",
}));

// Maintains it's touch size, but stops the touch size from affecting the layout
const ButtonShrinker = styled("div")(({ theme }) => ({
  marginBlock: -(theme.spacing(3) - 1),
}));

/**
 * The header for a dialog.
 *
 * @param title The title of the dialog.
 * @param onClose The callback for the close icon. If not supplied, the close icon will not show.
 * @param children The content of the header. If supplied, the title and close icon will not show.
 *
 * All other props are passed to the root element.
 */
export const DialogHeader: FC<
  { title: string; onClose?: () => void } & React.ComponentProps<"div">
> = ({ title, onClose, ...restProps }) => {
  return (
    <Header {...restProps}>
      {restProps.children || (
        <>
          <Typography
            variant="h5"
            component="h2"
            style={{ fontWeight: "bold" }}
          >
            {title}
          </Typography>
          {onClose && (
            <ButtonShrinker>
              <IconButton
                aria-label="close"
                data-testid={"Modal.closeIcon"}
                onClick={onClose}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </ButtonShrinker>
          )}
        </>
      )}
    </Header>
  );
};
